import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as Student from 'actions/Student';

export function* onGetStudentRequest({ params, cb }) {
  try {
    const student = yield axios.get(`/api/student/${params}`);
    yield put(Student.onGetStudentSuccess(student.data || []));
    cb && cb(true);
  } catch (e) {
    yield put(Student.onGetStudentFailure({ message: e.toString(), error: e }));
    cb && cb(e);
  }
}